import React from 'react'

const TelecomandFTTxSolutions = () => {
  return (
    <>
      <div className="container-fluid pt-5 hero-header mb-5">
        <div className="slider-container">
          <div className="slide2">
            <div className="container pt-5">
              <div className="row g-5 pt-5">
                <div className="col-lg-8 align-self-center text-center text-lg-start mb-lg-5">
                  <h1 className="display-6 text-white mb-1 animated slideInRight">
                    Telecom and FTTx Solutions
                  </h1>
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb justify-content-center justify-content-lg-start mb-0">
                      <li className="breadcrumb-item">
                        <a className="text-white" href="/">
                          Home
                        </a>
                      </li>
                      <li className="breadcrumb-item">
                        <a className="text-white" href="/solutions">
                          Solutions
                        </a>
                      </li>
                      <li
                        className="breadcrumb-item text-white active"
                        aria-current="page"
                      >
                        Telecom and FTTx Solutions
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid py-5">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6 wow fadeIn" data-wow-delay="0.1s">
              <div className="about-img about-img-cont">
                <img
                  className="img-fluid"
                  src="img/futuristic-computer-network-connects-global-industry-modern-warehouse-generated-by-artificial-intelligence.jpg"
                  alt="Futuristic computer network connects global industry in a modern warehouse"
                />
              </div>
              <div className="box green" />
            </div>
            <div className="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
              <div className="btn btn-sm border rounded-pill text-warningS px-3 mb-3">
                Telecom and FTTx Solutions
              </div>
              <h1 className="mb-4">
                RScom Network{" "}
                <span className="more-about-us-home">
                  - Leading Provider of Flexible Network Infrastructure
                  Solutions
                </span>
              </h1>
              <p className="mb-4">
                RScom Network offers advanced telecom and FTTx solutions designed to meet the evolving needs of telecom operators and FTTx deployments. Our comprehensive range of products is engineered to deliver cutting-edge network infrastructure, scalable fiber optic solutions, and versatile rack systems for seamless connectivity and efficient deployment.
              </p>
              <div className="row g-3">
                <div className="col-sm-6">
                  <h6 className="mb-3">
                    <i className="fa fa-check text-warningS me-2" />
                    Expertise
                  </h6>
                  <h6 className="mb-0">
                    <i className="fa fa-check text-warningS me-2" />
                    Quality Assurance
                  </h6>
                </div>
                <div className="col-sm-6">
                  <h6 className="mb-3">
                    <i className="fa fa-check text-warningS me-2" />
                    Scalability
                  </h6>
                  <h6 className="mb-0">
                    <i className="fa fa-check text-warningS me-2" />
                    Customer Satisfaction
                  </h6>
                </div>
              </div>
              <div className="d-flex align-items-center mt-4">
                <a
                  className="btn btn-warningS rounded-pill px-4 me-3"
                  href="Rscom_datasheet.pdf"
                >
                  Read PDF
                </a>
                <a
                  className="btn btn-warningS rounded-pill px-4 me-3"
                  href="/solutions"
                >
                  See all Solutions ..
                </a>
              </div>
            </div>
            <h5 className="mb-0">Cutting-Edge Network Infrastructure </h5>
            <p className="mb-0">
              Stay ahead of the curve with our cutting-edge network infrastructure solutions for telecom operators. From backbone networks to last-mile connectivity, our products are designed to meet the demands of today's telecom landscape, providing the reliability, performance, and scalability required for next-generation telecommunications.


            </p>
            <h5 className="mb-0">Scalable Fiber Optic Solutions</h5>
            <p className="mb-0">
              Deliver high-speed internet access to residential and business customers with our scalable fiber optic solutions. Whether you're deploying fiber to the home (FTTH) or fiber to the x (FTTx), our products provide the bandwidth and reliability needed to support bandwidth-intensive applications and services, ensuring a seamless and high-quality user experience.
            </p>
            <h5 className="mb-0">Versatile Rack Systems </h5>
            <p className="mb-0">
              Simplify installation and maximize space efficiency with our versatile rack systems designed for telecom facilities and FTTx cabinets. Our rack solutions are modular and adaptable, allowing for easy installation and customization to meet the unique requirements of telecom infrastructure deployments.
            </p>
            <h5 className="mb-0">
              Learn More About Our Telecom and FTTx Solutions{" "}
            </h5>
            <p className="mb-0">
              Explore our range of telecom and FTTx solutions to discover how RScom Network can help you build a reliable and scalable network infrastructure for your telecom operations and FTTx deployments. <a href="/contact">Contact us</a> today to speak with one of our experts and discuss your specific requirements.
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default TelecomandFTTxSolutions